import queryString from 'query-string';

import jwt_decode, { InvalidTokenError } from 'jwt-decode';
import { AuthenticationError, getErrorMessage } from 'shared/errors';
import { base64urlEncode, dec2hex, generateHash } from 'shared/utils';
import { type ISamoletAuthQueryParams } from './types';
import { samoletAuthConfig } from './config';

export const isAuthCompletePage = () =>
  location.href.includes(samoletAuthConfig.links.complete);

export const getAuthQueryParams = () =>
  queryString.parse(location.search) as Partial<ISamoletAuthQueryParams>;

export const generateCodeChallengeFromVerifier = async (plain: string) => {
  const hashed = await generateHash(plain, samoletAuthConfig.crypto);

  return base64urlEncode(hashed);
};

export const generateCodeVerifier = () => {
  const array = window.crypto.getRandomValues(new Uint32Array(56 / 2));

  return Array.from(array, dec2hex).join('');
};

export const isAccessTokenExpires = (accessToken: string) => {
  try {
    const data = jwt_decode<{ exp: number }>(accessToken);

    return Date.now() > data.exp * 1000;
  } catch (error: unknown) {
    throw new AuthenticationError(
      `Catch error while check for access token expires: ${getErrorMessage(error)}`,
    );
  }
};

export const isAccessTokenValid = (accessToken: string) => {
  try {
    return Boolean(jwt_decode(accessToken));
  } catch (error) {
    if (error instanceof InvalidTokenError) {
      return false;
    }
  }
};
